import { useState, useEffect } from 'react'

/**
 * Reactive hook tracking browser online/offline status.
 * Returns `true` by default (SSR-safe).
 *
 * @example
 * const isOnline = useOnlineStatus()
 * if (!isOnline) return <OfflineBanner />
 */
export function useOnlineStatus(): boolean {
  const [isOnline, setIsOnline] = useState(() =>
    typeof navigator !== 'undefined' ? navigator.onLine : true,
  )

  useEffect(() => {
    const goOnline = () => setIsOnline(true)
    const goOffline = () => setIsOnline(false)

    window.addEventListener('online', goOnline)
    window.addEventListener('offline', goOffline)

    return () => {
      window.removeEventListener('online', goOnline)
      window.removeEventListener('offline', goOffline)
    }
  }, [])

  return isOnline
}
